import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { LgpHeroStickyQuery, LgpHeroStickySubscription } from '../types';

const isSubscription = (
  container: LgpHeroStickySubscription | LgpHeroStickyQuery
): container is LgpHeroStickySubscription =>
  container.data.hasOwnProperty('onUpdateLgpHeroStickyBySeasonAndCompIdAndGpId');

export const getWidget = (container: LgpHeroStickySubscription | LgpHeroStickyQuery) =>
  isSubscription(container)
    ? container.data.onUpdateLgpHeroStickyBySeasonAndCompIdAndGpId
    : container.data.getLgpHeroStickyWidget;

/**
 * typeguard for ILgpHeroStickyQuery
 * @param LgpHeroSticky object passed to transformer
 */
export const isValidLgpHeroSticky = (LgpHeroSticky: LgpHeroStickySubscription | LgpHeroStickyQuery): boolean =>
  LgpHeroSticky && LgpHeroSticky.data ? Boolean(getWidget(LgpHeroSticky) && !isEmptyObject(getWidget(LgpHeroSticky))) : false;
